<template>
    <el-dialog :visible.sync="show" :title="name" width="900px">
        <el-form ref="form" size="small" :model="data" label-width="auto" label-position="right" :rules="rules">
            <el-form-item prop="name" label="模型名称">
                <el-input v-model="data.name" placeholder="输入模型名称" type="text"></el-input>
            </el-form-item>
            <el-form-item prop="code" label="模型编码">
                <el-input v-model="data.code" placeholder="输入模型编码" type="text" :readonly="!isCreate"></el-input>
            </el-form-item>
            <el-form-item prop="parentCode" label="主模型">
                <el-select v-model="data.parentCode" placeholder="请选择主模型" clearable filterable style="width: 100%"
                           @change="changeParentCode" :disabled="!isCreate">
                    <el-option v-for="(item, index) in parentList" :key="index" :value="item.code"
                               :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="fieldIds" label="自动生成字段">
                <el-select v-model="data.fieldIds" placeholder="选择自动生成字段" clearable filterable multiple
                           :disabled="!isCreate"
                           style="width: 100%">
                    <el-option v-for="(item, index) in fieldList" :key="index" :value="item.id"
                               :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="dataId" label="数据库">
                <el-select filterable default-first-option v-model="data.dataId" placeholder="选择数据库"
                           style="width: 100%">
                    <el-option :label="item.name" :value="item.id" v-for="(item, key) in dataList" :key="key">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="tableName" label="数据库表名">
                <el-input v-model="data.tableName" placeholder="输入数据库表名" type="text"
                          :readonly="!isCreate"></el-input>
            </el-form-item>
            <el-form-item prop="isJoin" label="是否关联表">
                <el-switch v-model="data.isJoin" active-color="#13ce66" inactive-color="#ff4949" active-text="是"
                           inactive-text="否"></el-switch>
            </el-form-item>
            <el-form-item prop="isTenant" label="是否企业查询">
                <el-switch v-model="data.isTenant" active-color="#13ce66" inactive-color="#ff4949" active-text="是"
                           inactive-text="否"></el-switch>
            </el-form-item>
            <el-form-item prop="isPlatform" label="是否站台查询">
                <el-switch v-model="data.isPlatform" active-color="#13ce66" inactive-color="#ff4949" active-text="是"
                           inactive-text="否"></el-switch>
            </el-form-item>
            <el-form-item prop="isSql" label="是否自定义Sql">
                <el-switch v-model="data.isSql" active-color="#13ce66" inactive-color="#ff4949" active-text="是"
                           inactive-text="否"></el-switch>
            </el-form-item>
            <el-form-item prop="filedContent" label="自定义Sql" v-if="data.isSql">
                <el-input v-model="data.filedContent" type="textarea" placeholder="输入自定义Sql"></el-input>
            </el-form-item>
        </el-form>
        <template slot="footer">
            <div style="text-align: center">
                <el-button type="primary" style="width: 100%" @click="save" :loading="loading">确定</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
export default {
    data() {
        return {
            show: false,
            name: '',
            data: {},
            rules: {
                name: [{required: true, trigger: 'change', message: '输入模型名称'}],
                code: [{required: true, trigger: 'change', message: '输入模型编码'}],
                tableName: [{required: true, trigger: 'change', message: '输入数据库表名'}],
                dataId: [{required: true, trigger: 'change', message: '选择数据库'}],
                filedContent: [{required: true, trigger: 'change', message: '输入自定义Sql'}],
            },
            loading: false,
            isCreate: false,
            dataList: [],
            parentList: [],
            fieldList: []
        }
    },
    methods: {
        display(data) {
            this.show = true
            this.data = data.data
            this.name = data.name
            this.isCreate = data.isCreate
            this.getDataList()
            this.getParentList()
        },

        getDataList() {
            const params = {
                params: {
                    pageNum: 1,
                    pageSize: 10000
                }
            }
            this.$axios.get('/query/dbInfo/list', params).then(res => {
                this.dataList = res.data.data.list
                this.$nextTick(() => {
                    this.$refs.form.clearValidate()
                })
            }).catch(err => {
                console.log('数据库列表错误：', err)
            })
        },

        getParentList() {
            this.$axios.get('/query/basicsModel/modelList').then(res => {
                this.parentList = res.data.data
                this.getFieldList()
            }).catch(() => {
            })
        },

        getFieldList() {
            this.fieldList = []
            this.parentList.forEach(item => {
                if (item.code === this.data.parentCode) {
                    this.$set(this, 'fieldList', item.fields)
                }
            })
        },

        changeParentCode() {
            this.$set(this.data, 'fieldIds', null)
            this.$set(this.data, 'parentId', null)
            this.$set(this.data, 'dataId', null)
            this.$set(this, 'fieldList', [])
            if (this.data.parentCode) {
                this.parentList.forEach(item => {
                    if (item.code === this.data.parentCode) {
                        this.$set(this, 'fieldList', item.fields)
                        this.$set(this.data, 'parentId', item.id)
                        this.$set(this.data, 'dataId', item.dataId)
                    }
                })
            }
        },

        save() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.loading = true
                    const params = JSON.parse(JSON.stringify(this.data))
                    this.dataList.forEach(item => {
                        if (item.id === this.data.dataId) params['dataName'] = item.name
                    })
                    const text = this.isCreate ? '创建' : '修改'
                    const url = this.isCreate ? '/query/basicsModel/save' : '/query/basicsModel/edit'
                    this.$axios.post(url, params).then(() => {
                        this.$message.success(`${text}成功`)
                        this.show = false
                        this.$emit('init')
                        this.loading = false
                    }).catch(err => {
                        console.log(`${text}失败`, err)
                        this.loading = false
                    })
                } else {
                    return false
                }
            })
        }
    }
}
</script>
